import styles from "./DownloadButton.module.css";
function DownloadButton({ children }) {
  const handleDownload = () => {
    // Replace 'sample.pdf' with the actual file name and extension
    const fileName = "Abiodun Akanbi CV.pdf";
    const fileUrl = "../../assets/Abiodun Akanbi CV.pdf";

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;

    // Append the link to the document and trigger the click event to start the download
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link element from the document
    document.body.removeChild(link);
  };
  return (
    <button onClick={handleDownload} className={styles.button}>
      {children} <span>&rarr;</span>
    </button>
  );
}

export default DownloadButton;
